import { Stack, Switch, Button } from "../../components";

export const BulkErrorHeader = (props: {
  detailedErrorView: boolean;
  setDetailedErrorView: (value: boolean) => void;
  showOnlySelectedWithErrors: boolean;
  setShowOnlySelectedWithErrors: (value: boolean) => void;
  removeSelectionWithErrors: () => void;
}) => {
  return (
    <Stack direction="row" justifyContent={"space-between"}>
      <Stack direction="row" spacing="sm">
        <Switch
          label="Detailed Errors"
          checked={props.detailedErrorView}
          onChange={(e) => props.setDetailedErrorView(e.target.checked)}
        ></Switch>

        {props.detailedErrorView && (
          <Switch
            label="Only Entries with Errors"
            checked={props.showOnlySelectedWithErrors}
            onChange={(e) => props.setShowOnlySelectedWithErrors(e.target.checked)}
          ></Switch>
        )}
      </Stack>

      <Button variant="outlined" onClick={() => props.removeSelectionWithErrors()}>
        Remove Selections with Errors
      </Button>
    </Stack>
  );
};
